import { call, put, takeEvery, select, fork } from "redux-saga/effects"
import { toast } from "react-toastify"
// Crypto Redux States
import BranchesType from "./actionTypes"
import BranchesAPI from "helpers/branches_backend_helper"
import BranchesAction from "./actions"
import moment from "moment"

// get global state
export const getState = ({ Users }) => Users

function* fetchBranchesListOnPage({ payload }) {
  yield put(
    BranchesAction.getListPageSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    const currentPage = payload.page
    let { data } = yield call(BranchesAPI.getListPage, {
      ...payload,
      page: currentPage,
    })
    yield put(
      BranchesAction.getListPageSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      BranchesAction.getListPageSuccess({
        loading: false,
        data: {},
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchBranchesListHistoryOnPage({ payload }) {
  yield put(
    BranchesAction.getListHistoryPageSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    const currentPage = payload.page
    let { data } = yield call(BranchesAPI.getListHistoryPage, {
      ...payload,
      page: currentPage,
    })
    yield put(
      BranchesAction.getListHistoryPageSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      BranchesAction.getListHistoryPageSuccess({
        loading: false,
        data: {},
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchBettingRates({ payload }) {
  yield put(
    BranchesAction.getBettingRatesListSuccess({
      loading: true,
      data: [],
    })
  )
  try {
    let { data } = yield call(BranchesAPI.getBettingRateType)
    console.log(data, "data")
    yield put(
      BranchesAction.getBettingRatesListSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    console.log(error)
    yield put(
      BranchesAction.getBettingRatesListSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchDetail({ payload, action }) {
  yield put(
    BranchesAction.getDetailSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(BranchesAPI.getDetail, payload.id)

    action(data)
    yield put(
      BranchesAction.getDetailSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    console.log(error)
    yield put(
      BranchesAction.getDetailSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchPostData({ payload, action }) {
  yield put(
    BranchesAction.postDataSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    payload.closingDate = moment(payload.closingDate).format("YYYY-MM-DD")
    payload.paymentDate = moment(payload.paymentDate).format("YYYY-MM-DD")
    let { data } = yield call(BranchesAPI.postData, payload)

    yield put(
      BranchesAction.postDataSuccess({
        loading: false,
        data,
      })
    )
    action()
  } catch (error) {
    console.log(error)
    yield put(
      BranchesAction.postDataSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchPutData({ payload, action }) {
  yield put(
    BranchesAction.putDataSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(BranchesAPI.putData, payload)

    yield put(
      BranchesAction.putDataSuccess({
        loading: false,
        data,
      })
    )
    action()
  } catch (error) {
    console.log(error)
    yield put(
      BranchesAction.putDataSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchList({ payload }) {
  yield put(
    BranchesAction.getListSuccess({
      loading: true,
      data: {},
    })
  )
  try {
    let { data } = yield call(BranchesAPI.getList)
    yield put(
      BranchesAction.getListSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      BranchesAction.getListSuccess({
        loading: false,
        data: {},
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchIgarashiList({ payload }) {
  yield put(
    BranchesAction.getIgarashiListSuccess({
      loading: true,
      data: [],
    })
  )
  try {
    let { data } = yield call(BranchesAPI.getIgarashiList)
    yield put(
      BranchesAction.getIgarashiListSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    console.log(error, "er")
    yield put(
      BranchesAction.getIgarashiListSuccess({
        loading: false,
        data: [],
        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* fetchOtherList({ payload }) {
  yield put(
    BranchesAction.getOtherListSuccess({
      loading: true,
      data: [],
    })
  )
  try {
    let { data } = yield call(BranchesAPI.getOtherList)
    yield put(
      BranchesAction.getOtherListSuccess({
        loading: false,
        data,
      })
    )
  } catch (error) {
    yield put(
      BranchesAction.getOtherListSuccess({
        loading: false,
        data: [],

        error:
          error?.message ||
          "保存に失敗しました。入力された内容をもう一度ご確認ください。",
      })
    )
  }
}

function* branchesSaga() {
  yield takeEvery(BranchesType.GET_BRANCHES_PAGES, fetchBranchesListOnPage)
  yield takeEvery(
    BranchesType.GET_BRANCHES_HISTORIES_PAGES,
    fetchBranchesListHistoryOnPage
  )
  yield takeEvery(BranchesType.GET_BRANCH_BETTING_RATE_TYPE, fetchBettingRates)
  yield takeEvery(BranchesType.GET_DETAIL_BRANCH_BY_ID, fetchDetail)
  yield takeEvery(BranchesType.POST_BRANCH, fetchPostData)
  yield takeEvery(BranchesType.PUT_BRANCH, fetchPutData)
  yield takeEvery(BranchesType.GET_BRANCHES_LIST, fetchList)
  yield takeEvery(BranchesType.GET_BRANCH_IGARASHI_LIST, fetchIgarashiList)
  yield takeEvery(BranchesType.GET_BRANCH_OTHER_LIST, fetchOtherList)
}

export default branchesSaga
